import { createBrowserRouter } from 'react-router-dom';
import { RootLayout, AuthLayout, GuestLayout } from './layouts';
import {
  HomePage,
  LoginPage,
  RegisterPage,
  ProfilePage,
  LeaderboardPage,
  SettingsPage,
  SinglePlayerSetupPage,
  MultiplayerPage,
  GamePage,
  NotFoundPage,
} from './pages';

export const router = createBrowserRouter(
  [
    {
      element: <RootLayout />,
      children: [
        // Guest-only routes (redirect if already logged in)
        {
          element: <GuestLayout />,
          children: [
            { path: '/login', element: <LoginPage /> },
            { path: '/register', element: <RegisterPage /> },
          ],
        },

        // Protected routes (redirect to login if not authenticated)
        {
          element: <AuthLayout />,
          children: [
            { path: '/', element: <HomePage /> },
            { path: '/profile', element: <ProfilePage /> },
            { path: '/settings', element: <SettingsPage /> },
            { path: '/play/single', element: <SinglePlayerSetupPage /> },
            { path: '/play/multiplayer', element: <MultiplayerPage /> },
            { path: '/game/:roomCode', element: <GamePage /> },
          ],
        },

        // Public routes
        { path: '/leaderboard', element: <LeaderboardPage /> },

        // 404
        { path: '*', element: <NotFoundPage /> },
      ],
    },
  ],
  { basename: import.meta.env.BASE_URL },
);
